import { executionEnvironment } from "@x1-utils/ExecutionEnvironment";

import { StyleXSheet } from "./StyleXSheet";

function toggleClass(element, className, condition) {
  condition
    ? element.classList.add(className)
    : element.classList.remove(className);
}

function updateDarkModeRootClass(status) {
  if (!executionEnvironment.canUseDOM) {
    return;
  }

  const rootElement = window.document.documentElement;

  toggleClass(
    rootElement,
    StyleXSheet.DARK_MODE_CLASS_NAME,
    status === "ENABLED",
  );

  toggleClass(
    rootElement,
    StyleXSheet.LIGHT_MODE_CLASS_NAME,
    status === "DISABLED" || status === "UNDECLARED",
  );
}

export const X1DarkModeRootClass = {
  updateDarkModeRootClass,
};
